import createTracker from '../../analytics/create-tracker';


const track = createTracker('web', 'syndicated');

/**
 * Catalog of analytics events triggered from Syndication features.
 * Provides a clean interface for describing the tracking events.
 */
export default {
  pocketHitsSignupFieldView: () => track('newsletter_email', undefined, 'view'),
  pocketHitsSignupFieldFocus: () => track('newsletter_email_focus', undefined, 'click'),
  pocketHitsSignupSubmit: () => track('newsletter_email_submit', undefined, 'click'),
  pocketHitsSignupSubmitSuccess: () => track('newsletter_email_success', undefined, 'interact'),
  pocketHitsSignupSubmitError: () => track('newsletter_email_error', undefined, 'interact'),
  pocketHitsFacebookShareClick: () => track('newsletter_email_facebook', undefined, 'interact'),
  pocketHitsTwitterShareClick: () => track('newsletter_email_twitter', undefined, 'interact'),
  pocketHitsLinkedInShareClick: () => track('newsletter_email_linkedin', undefined, 'interact'),
  pocketHitsEmailConfirmSuccess: () => track('email_confirm', undefined, 'view'),
};
